<template>
    <v-container>
        <v-layout row wrap>
           <v-flex md4 offset-md4>
               <v-card>
                   <v-card-title>
                       Внимание!
                   </v-card-title>
                   <v-divider></v-divider>
                   <v-card-text class="text-md-center">
                       Модуль находится в разработке
                   </v-card-text>
               </v-card>
           </v-flex>
        </v-layout>

    </v-container>
</template>

<script>
  import store from '@/store'
  import draggable from 'vuedraggable'
  export default {
    data () {
      return {
        interval: {},
        value: 0,
        modules: store.getters.getModuleList
      }
    },
    components: {
      draggable
    },
    beforeDestroy () {
      clearInterval(this.interval)
    },
    mounted () {
      store.commit('setPageTitle', '')
      this.interval = setInterval(() => {
        if (this.value === 100) {
          return (this.value = 0)
        }
        this.value += 10
      }, 1000)
    }
  }
</script>